import { forwardRef } from "react";
import { FiHelpCircle } from "react-icons/fi";

// https://github.com/react-bootstrap/react-bootstrap/issues/6194
const LobbieHelpIcon = forwardRef((props: any, ref: React.Ref<any>) => {
    const { size, ...rest } = props;
    return (
        <span ref={ref} {...rest}>
            <FiHelpCircle fontSize={size ? size : undefined} className="blue" />
        </span>
    );
});

export default LobbieHelpIcon;
